import React from 'react';
import PropTypes from 'prop-types';

import {
  Tooltip,
  Typography, 
} from '@material-ui/core';

import { UserContext } from "../../user";

import { fmtClient } from "../formatters";

export default function ClientName(props) {
  const { id, tooltip, raw } = props;
  const userContext=React.useContext(UserContext); 
  const name=userContext?fmtClient(id,userContext):id;
  if ( tooltip && name!==id) {
    return(
      <Tooltip title={
            <Typography>{"Account Id: "+id}</Typography>
        } enterDelay={1000} leaveDelay={200} arrow>
      <p>{name}</p>
      </Tooltip>
    );
  } else if(raw) {
    return (name);
  } else {
    return (
        <p>{name}</p>
    );
  }
}

ClientName.propTypes = {
  id: PropTypes.string.isRequired,
  tooltip: PropTypes.bool.isRequired,
  raw: PropTypes.bool.isRequired,
};

ClientName.defaultProps = {
  tooltip: false,
  raw: false,
};
